import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Menu.css";

export default function Menu({ user, setUser }) {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const mobileMenuRef = useRef(null);

  const API_URL = process.env.REACT_APP_API_URL;

  const backToHomepage = () => {
    navigate(`/`);
    window.location.reload();
  };
  const toCreate = () => navigate(`/create`);

  const handleLogout = async () => {
    await fetch(`${API_URL}/api/logout`, {
      method: "POST",
      credentials: "include",
    });
    setUser(null);
    window.location.reload();
    navigate("/");
  };

  const handleLoginClick = () => {
    setShowDropdown(false);
    navigate("/login");
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const profileImgSrc =
    user && user.profile_img
      ? `/semesterprojekt/backend/uploads/profileImg/${user.profile_img}`
      : "https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png";

  const goToProfile = () => {
    navigate("/profile");
  };

  const toAbout = () => {
    navigate("/about");
  };

  return (
    <div className="menuBar flex space-between flexMobile">
      <div
        style={{ fontWeight: "400", fontSize: "2.5em", cursor: "pointer" }}
        onClick={backToHomepage}
        className="inter"
      >
        <b>splash</b> overflow
      </div>

      <div
        className="hamburger"
        onClick={() => setShowMobileMenu((prev) => !prev)}
      >
        ☰
      </div>

      <div className="flex items-center">
        <div className="flex items-center menuButtons inter">
          <div onClick={backToHomepage}>Home</div>
          <div onClick={toCreate}>Create</div>
          <div onClick={toAbout}>About</div>
        </div>

        {showMobileMenu && (
          <div className="mobileDropdown" ref={mobileMenuRef}>
            <div
              onClick={() => {
                setShowMobileMenu(false);
                backToHomepage();
              }}
            >
              Home
            </div>
            <div
              onClick={() => {
                setShowMobileMenu(false);
                toCreate();
              }}
            >
              Create
            </div>
            <div
              onClick={() => {
                setShowMobileMenu(false);
                toAbout();
              }}
            >
              About
            </div>
            {user ? (
              <>
                <br></br>
                <div
                  onClick={() => {
                    setShowMobileMenu(false);
                    goToProfile();
                  }}
                >
                  Profil
                </div>
                <div
                  onClick={() => {
                    setShowMobileMenu(false);
                    handleLogout();
                  }}
                >
                  Logout
                </div>
              </>
            ) : (
              <div
                onClick={() => {
                  setShowMobileMenu(false);
                  handleLoginClick();
                }}
              >
                Login
              </div>
            )}
          </div>
        )}

        <div
          className="relative flex items-center profileImg"
          ref={dropdownRef}
        >
          <img
            className="profileImgMenu"
            src={profileImgSrc}
            alt="Profil"
            onClick={() => setShowDropdown((prev) => !prev)}
            style={{ cursor: "pointer" }}
          />

          {showDropdown && (
            <div className="dropdownMenu">
              {user ? (
                <>
                  <div className="dropdownItem" onClick={goToProfile}>
                    Profil
                  </div>
                  <div className="dropdownItem" onClick={handleLogout}>
                    Logout
                  </div>
                </>
              ) : (
                <div className="dropdownItem" onClick={handleLoginClick}>
                  Login
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
